<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_question") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ $t("PLACEHOLDERS.choose_type") }}</h3>

            <div class="type-selector">
              <label
                v-for="type in questionTypes"
                :key="type.value"
                class="custom-radio"
                :class="{ selected: data.type === type.value }"
              >
                <input type="radio" :value="type.value" v-model="data.type" />
                <span class="radio-label">{{ $t(type.label) }}</span>
              </label>
            </div>
          </div>

          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.question')"
            v-model.trim="data.question"
            required
          />
          <audio-upload
            class="mt-2 col-lg-6"
            v-model="data.audio"
            :preSelected="data.audio"
            @file-selected="handleAudioSelected"
            @file-removed="handleAudioRemoved"
            :label="$t('PLACEHOLDERS.record')"
          />
          <div
            v-if="data.type === 'mcq' || data.type === 'multi_choice'"
            class="row"
          >
            <div
              v-for="(answer, idx) in 4"
              :key="idx"
              class="col-md-6 mb-2 d-flex align-items-start gap-2"
            >
              <template v-if="data.type === 'mcq'">
                <input
                  type="radio"
                  :name="'correctAnswer'"
                  :value="idx"
                  v-model="data.correctAnswer"
                  style="margin-right: 8px"
                />
              </template>
              <template v-else>
                <input
                  type="checkbox"
                  :value="idx"
                  v-model="data.correctAnswers"
                  style="margin-right: 8px"
                />
              </template>
              <base-text-editor
                :placeholder="$t(`PLACEHOLDERS.answer${idx + 1}`)"
                v-model.trim="data.answers[idx]"
                required
                style="flex: 1"
              />
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
            />
          </div>

          <!-- Start:: True/False Type -->
          <div v-if="data.type === 'true_false'" class="row">
            <div class="col-md-6 mb-2 d-flex align-items-center gap-2">
              <label
                class="custom-radio"
                :class="{ selected: data.trueFalseAnswer === true }"
              >
                <input
                  type="radio"
                  name="trueFalseAnswer"
                  :value="true"
                  v-model="data.trueFalseAnswer"
                />
                <span class="radio-label">{{ $t("PLACEHOLDERS.true") }}</span>
              </label>
              <label
                class="custom-radio"
                :class="{ selected: data.trueFalseAnswer === false }"
              >
                <input
                  type="radio"
                  name="trueFalseAnswer"
                  :value="false"
                  v-model="data.trueFalseAnswer"
                />
                <span class="radio-label">{{ $t("PLACEHOLDERS.false") }}</span>
              </label>
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
            />
          </div>
          <!-- End:: True/False Type -->

          <!-- Start:: Match Type -->
          <div
            v-if="data.type === 'match' || data.type == 'orderd'"
            class="row justify-content-center"
          >
            <div class="col-l2" v-if="data.matchPairs?.length < 4">
              <div class="add_another" @click="addMatchRow">
                <i class="fas fa-plus"></i>
              </div>
            </div>

            <div
              class="col-lg-6 col-12"
              v-for="(pair, idx) in data.matchPairs"
              :key="'match' + idx"
            >
              <div class="item d-flex align-items-center gap-2">
                <base-input
                  class="w-100"
                  type="text"
                  :placeholder="
                    data.type == 'orderd'
                      ? $t('PLACEHOLDERS.ordered_phrase')
                      : $t('PLACEHOLDERS.match_question')
                  "
                  v-model.trim="pair.question"
                />
                <base-input
                  class="w-100"
                  :type="data.type == 'orderd' ? 'number' : 'text'"
                  :placeholder="
                    data.type == 'orderd'
                      ? $t('PLACEHOLDERS.ordered_order')
                      : $t('PLACEHOLDERS.match_answer')
                  "
                  v-model.trim="pair.answer"
                />
                <div class="all_actions" v-if="data.matchPairs.length > 2">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeMatchRow(idx)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.question_degree')"
              v-model.trim="data.questionDegree"
              required
            />
          </div>
          <!-- End:: Match Type -->

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>
<script>
import moment from "moment";
import FileUpload from "../../../components/formInputs/FileUpload.vue";
import AudioUpload from "../../../components/formInputs/AudioUpload.vue";

export default {
  name: "CreateBanks",
  components: { FileUpload, AudioUpload },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        type: "mcq",
        question: "",
        correctAnswer: 0, // index of correct answer for mcq
        correctAnswers: [], // array of correct answers for multi_choice
        answers: ["", "", "", ""], // for MCQ/multi_choice answers
        audio: null, // for audio file or url
        matchPairs: [
          { question: "", answer: "" },
          { question: "", answer: "" },
        ],
        orderedPairs: [
          { question: "", answer: 1 },
          { question: "", answer: 2 },
        ],
        trueFalseAnswer: null,
      },
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },
  watch: {
    "data.type"() {
      this.data.matchPairs = [
        { question: "", answer: "" },
        { question: "", answer: "" },
      ];
    },
  },
  computed: {
    questionTypes() {
      return [
        { value: "mcq", label: "PLACEHOLDERS.mcq" },
        { value: "match", label: "PLACEHOLDERS.match" },
        { value: "multi_choice", label: "PLACEHOLDERS.multi_choice" },
        { value: "true_false", label: "PLACEHOLDERS.true_false" },
        { value: "orderd", label: "PLACEHOLDERS.ordered" },
      ];
    },
  },

  methods: {
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
    handleFileRemove(index) {
      this.existingFiles.splice(index, 1);
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    handleFileSelected({ file, fileType }) {
      this.file = file;
      this.fileType = fileType;
    },
    handleFileRemoved() {
      this.file = null;
      this.fileType = "";
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    handleAudioSelected(file) {
      this.data.audioFile = file;
    },
    handleAudioRemoved() {
      this.data.audioFile = null;
      this.data.audio = null;
    },

    addMatchRow() {
      if (this.data.matchPairs.length < 4) {
        this.data.matchPairs.push({ question: "", answer: "" });
      }
    },
    removeMatchRow(idx) {
      if (this.data.matchPairs.length > 2) {
        this.data.matchPairs.splice(idx, 1);
      }
    },
    addOrderedRow() {
      if (this.data.orderedPairs.length < 4) {
        this.data.orderedPairs.push({
          question: "",
          answer: this.data.orderedPairs.length + 1,
        });
      }
    },
    removeOrderedRow(idx) {
      if (this.data.orderedPairs.length > 2) {
        this.data.orderedPairs.splice(idx, 1);
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("type", this.data.type);
      REQUEST_DATA.append("question", this.data.question);

      // Optionally append MCQ/multi_choice data
      if (this.data.type === "mcq" || this.data.type === "multi_choice") {
        this.data.answers.forEach((ans, idx) => {
          REQUEST_DATA.append(`answers[${idx}][answer]`, ans);
          if (this.data.type === "mcq") {
            REQUEST_DATA.append(
              `answers[${idx}][is_correct]`,
              idx === this.data.correctAnswer ? 1 : 0
            );
          } else if (this.data.type === "multi_choice") {
            REQUEST_DATA.append(
              `answers[${idx}][is_correct]`,
              this.data.correctAnswers.includes(idx) ? 1 : 0
            );
          }
        });
      }

      if (this.data.type === "true_false") {
        REQUEST_DATA.append("answers[0][answer]", "true");

        REQUEST_DATA.append("answers[1][answer]", "false");

        REQUEST_DATA.append(
          "answers[0][is_correct]",
          this.data.trueFalseAnswer === true ? 1 : 0
        );

        REQUEST_DATA.append(
          "answers[1][is_correct]",
          this.data.trueFalseAnswer === false ? 1 : 0
        );
      }

      if (this.data.type === "match") {
        this.data.matchPairs.forEach((pair, idx) => {
          REQUEST_DATA.append(`answers[${idx}][question]`, pair.question);
          REQUEST_DATA.append(`answers[${idx}][answer]`, pair.answer);
        });
      }

      if (this.data.type === "orderd") {
        this.data.matchPairs.forEach((pair, idx) => {
          console.log(pair);
          REQUEST_DATA.append(`answers[${idx}][answer]`, pair.question);
          REQUEST_DATA.append(`answers[${idx}][orderd]`, pair.answer);
        });
        REQUEST_DATA.append("question_type", "ordered");
      }

      if (this.data.audioFile) {
        REQUEST_DATA.append("file", this.data.audioFile);
      }
      REQUEST_DATA.append("exam_id", this.$route.params?.id);
      REQUEST_DATA.append("question_mark", this.data.questionDegree);

      try {
        await this.$axios({
          method: "POST",
          url: `questions`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({
          path: `/exams/show/${this.$route.params?.id}/questions`,
        });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },
};
</script>
<style>
:root {
  --main_theme_clr: #0b7477;
}

.type-selector {
  font-family: "Cairo", sans-serif;
  margin: auto;
  padding: 0px 8px;
  display: flex;
  gap: 4px;
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 2px solid var(--main_theme_clr);
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}
.custom-radio.disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}
.custom-radio input[type="radio"] {
  display: none;
}
.custom-radio input[type="radio"]:disabled {
  cursor: not-allowed !important;
}
.custom-radio .radio-label {
  font-size: 16px;
  font-weight: bold;
  color: var(--main_theme_clr);
}
.custom-radio.selected {
  border-color: var(--main_theme_clr);
  background-color: #e6f8f8;
}
.custom-radio.selected .radio-label {
  color: var(--main_theme_clr);
}

.selected-type {
  margin-top: 20px;
  font-size: 16px;
  color: #444;
}
/* Audio upload style override for better integration */
.audio-upload-wrapper {
  margin-bottom: 12px;
  width: 100%;
}

/* Example: Use theme color for button (if you want) */
.primary_btn {
  background: var(--main_theme_clr) !important;
  border-color: var(--main_theme_clr) !important;
  color: #fff !important;
}
</style>
